module.exports = __webpack_public_path__ + "static/media/escape_asylum.e8d3ee9a.jpg";